import { Component, OnInit } from '@angular/core';
import { User } from 'src/app/objects/user';
import { AuthService } from 'src/app/services';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  account: User = null;
  constructor(private authService: AuthService) { }

  ngOnInit() {
    this.authService.account.subscribe((x) => {
      this.account = x;
    });
  }

  logout() {
    this.authService.logout();
  }

}
